import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-88f9957e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "outer" };
const _hoisted_2 = {
    class: "tabs",
    group: "main-tabs",
    "item-key": "tab"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "label" };
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import { useMessage } from '@/const/messages';
import { ref } from 'vue';
import { useStore } from '@/store/store';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean }
    },
    emits: ["click", "reload"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const store = useStore();
        const onClick = (value) => emits('click', value);
        const onReload = (value) => emits('reload', value);
        const { HEADER_TABS, format } = useMessage();
        const defaultTabs = [
            {
                tab: 'trade',
                display: HEADER_TABS.TRADE,
            },
            {
                tab: 'staking',
                display: HEADER_TABS.STAKING,
            },
            {
                tab: 'history',
                display: HEADER_TABS.HISTORY,
            },
            {
                tab: 'mypage',
                display: HEADER_TABS.MYPAGE,
            },
        ];
        const initTabs = defaultTabs;
        const menus = ref(initTabs);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menus.value, (element) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                            key: element.tab
                        }, [
                            (props.isAuth || element.tab === 'trade' || element.tab === 'staking')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["tab", _unref(store).state.tab !== element.tab ? 'non' : 'select']),
                                    onClick: ($event) => (onClick(element.tab))
                                }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass({ cover: _unref(store).state.tab === element.tab })
                                    }, null, 2),
                                    _createElementVNode("div", _hoisted_4, [
                                        (_unref(store).state.tab === element.tab)
                                            ? (_openBlock(), _createBlock(MaterialIcon, {
                                                key: 0,
                                                name: "refresh",
                                                class: "icon",
                                                onClick: ($event) => (onReload(element.tab))
                                            }, null, 8, ["onClick"]))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", null, _toDisplayString(_unref(format)(element.display)), 1)
                                    ])
                                ], 10, _hoisted_3))
                                : _createCommentVNode("", true)
                        ], 64));
                    }), 128))
                ])
            ]));
        };
    }
});
